<div class="col-12 align-right">
  <button type="button" [icon]="'fa fa-hand-o-right'"
          [label]="'COMMON.NEXT' | translate" pButton (click)="storeSignaturePosition()"></button>
</div>
<div class="col-12">
  <div class="col-3">
    <div class="col-6" *ngIf="sigPages && sigPages.length > 1">
      {{'UPLOAD_COMPONENT.SIG_PAGE_SELECTION_LABEL' | translate}}
    </div>
    <div class="col-6" *ngIf="sigPages && sigPages.length > 1">
      <p-dropdown [options]="sigPages" [(ngModel)]="selectedSignaturePage" [dataKey]="'value'"></p-dropdown>
    </div>
  </div>
  <div class="col-6">
    <p-fieldset [legend]="'UPLOAD_COMPONENT.SIG_PREVIEW' | translate"
                *ngIf="pagesImages && pagesImages.hasOwnProperty('page_1')">
      <div class="col-12" *ngIf="pageCount > 1">
        <p-paginator [rows]="1" [totalRecords]="pageCount" [showCurrentPageReport]="true"
                     [currentPageReportTemplate]="'Page: {currentPage} sur {totalPages}'"
                     (onPageChange)="updateCustomizationViewer($event)"></p-paginator>
      </div>
      <div class="col-12 sig-page-label" *ngIf="pages && pages.length > 0">
        {{'UPLOAD_COMPONENT.SIG_PAGE_LABEL' | translate}} {{selectedSignaturePage}}
      </div>
      <div class="col-12">
        <div class="extract-region-container" #customPreviewContainer>
          <div class="extract-region-bg" [ngStyle]="customizeContainerBGStyle">
            <div class="signature-rect" #sigContainer [ngStyle]="sigContainerStyle"
                 *ngIf="selectedSignaturePage === selectedCustomizationPage"
                 ngResizable
                 ngDraggable
                 [rzHandles]="'n,e,s,w,se,sw,ne,nw'"
                 (endOffset)="recalculateSigPosition()"
                 (rzStop)="recalculateSigPosition()"
                 [bounds]="customPreviewContainer"
                 rzContainment="#customPreviewContainer"
                 [inBounds]="true"
            ></div>
          </div>
        </div>
      </div>
    </p-fieldset>
  </div>
  <div class="col-3"></div>
</div>
